module.exports = __webpack_public_path__ + "img/left_training_3.e3e49162.svg";